export default function isFeatureToggleOn(feature) {
  if (window.playback_feature_toggle) {
    return window.playback_feature_toggle.indexOf(feature) >= 0;
  }
  return false;
}

export function isFeatureToggleOff(feature) {
  return !isFeatureToggleOn(feature);
}
